<script setup>
import Index from "@/views/data/dataset/index.vue"

definePage({
  meta: {
    action: 'read',
    subject: 'data-dataset',
  },
})

const router = useRouter()

const tab = router.currentRoute.value.params.tab
</script>

<template>
  <Index :tab="tab" />
</template>
